import ApiService, { errorMessage } from "helpers/ApiHelper";

const ROOT = "/api/v1/redirects";

export { errorMessage };

/**
 * Every rule, with notes and timestamps — unlike the public read, which serves
 * only what the hpn-landing build needs to emit host redirect rules.
 */
export const fetchRedirects = () => ApiService.request(ROOT, "get");

export const createRedirect = (redirect) => ApiService.request(ROOT, "post", redirect);

/**
 * PATCH is partial on this endpoint, but this screen always sends the whole
 * row: the form holds every field, and a partial send would make "clear the
 * note" indistinguishable from "leave the note alone".
 */
export const updateRedirect = (id, redirect) =>
  ApiService.request(`${ROOT}/${id}`, "patch", redirect);

export const deleteRedirect = (id) => ApiService.request(`${ROOT}/${id}`, "delete");
